import { InfiniteScroll } from "../components/InfiniteScroll";
import { CascadingSelectForItems } from "../components/CascadingSelectForItems";

const ITEM_TEMPLATE_CLASSNAME = "js-item-template";
const ITEM_CLASSNAME = "js-item";
const ITEM_LINK_CLASSNAME = `${ITEM_CLASSNAME}-link`;
const ITEM_IMAGE_CLASSNAME = `${ITEM_CLASSNAME}-image`;
const ITEM_TAG_TYPE_CLASSNAME = `${ITEM_CLASSNAME}-tag-type`;
const ITEM_MIME_TYPE_CLASSNAME = `${ITEM_CLASSNAME}-mime-type`;
const ITEM_TITLE_CLASSNAME = `${ITEM_CLASSNAME}-title`;
const ITEM_SUMMARY_CLASSNAME = `${ITEM_CLASSNAME}-summary`;
const ITEM_PRICE_CLASSNAME = `${ITEM_CLASSNAME}-price`;
const NO_ITEM_LIST_CLASSNAME = "js-no-item-list";

class ItemList {
  itemTemplate = null;

  constructor() {
    this.setUpInfiniteScroll();
  }

  static stringToNode(markupString, parentTag = "div") {
    const $tempDiv = document.createElement(parentTag);
    $tempDiv.innerHTML = markupString;
    return $tempDiv.firstChild;
  }

  setUpInfiniteScroll() {
    this.itemTemplate = document.querySelector(`.${ITEM_TEMPLATE_CLASSNAME}`);
    if (!this.itemTemplate) {
      return;
    }

    const insertItem = ($targetElement, itemObj, currentPage) => {
      const {
        image: itemImage,
        item_url: itemUrl,
        item_type: itemType,
        item_mime_type: itemMimeType,
        item_title: itemTitle,
        item_description: itemDescription,
        list_price: itemPrice,
        item_attributes: itemAttributes
      } = itemObj;
      const $itemElement = this.itemTemplate.content.cloneNode(true);
      const $itemCard = $itemElement.querySelector(`.${ITEM_CLASSNAME}`);
      $itemCard.dataset.currentPage = currentPage;
      const $itemLink = $itemElement.querySelector(`.${ITEM_LINK_CLASSNAME}`);
      $itemLink.href = itemUrl;
      const $itemImage = $itemElement.querySelector(`.${ITEM_IMAGE_CLASSNAME}`);
      $itemImage.replaceWith(ItemList.stringToNode(itemImage));
      const $itemTagType = $itemElement.querySelector(`.${ITEM_TAG_TYPE_CLASSNAME}`);
      $itemTagType.replaceWith(ItemList.stringToNode(itemType, "ul"));
      const $itemMimeType = $itemElement.querySelector(`.${ITEM_MIME_TYPE_CLASSNAME}`);
      $itemMimeType.replaceWith(ItemList.stringToNode(itemMimeType, "ul"));
      const $itemTitle = $itemElement.querySelector(`.${ITEM_TITLE_CLASSNAME}`);
      $itemTitle.innerText = itemTitle;
      const $itemSummary = $itemElement.querySelector(`.${ITEM_SUMMARY_CLASSNAME}`);
      $itemSummary.innerHTML = itemDescription;
      const $itemPrice = $itemElement.querySelector(`.${ITEM_PRICE_CLASSNAME}`);
      $itemPrice.innerText = itemPrice;

      $targetElement.appendChild($itemElement);

      if (itemAttributes) {
        $itemCard.classList.add(itemAttributes.class);
        const $pictureElement = $itemCard.querySelector("picture");
        $pictureElement.setAttribute("before-content", itemAttributes.content);
      }
    };

    document.addEventListener(InfiniteScroll.infiniteScrollDataLoadedEventName, (e) => {
      const { apiResponse, targetElement, currentPage } = e.detail;
      const { success, productList } = apiResponse.data;
      if (success) {
        if (currentPage === 1 && productList.length === 0) {
          const $noItemList = document.querySelector(`.${NO_ITEM_LIST_CLASSNAME}`);
          $noItemList.removeAttribute("hidden");
        }
        if (productList.length) {
          [...productList].forEach((itemObj) => {
            insertItem(targetElement, itemObj, currentPage);
          });
        }
      }
    });
  }
}

export { ItemList };

window.addEventListener("load", () => {
  // eslint-disable-next-line no-unused-vars
  const itemList = new ItemList();
  CascadingSelectForItems.attach();
});
